import React from "react";

import { progressFillPercent } from "helpers/progress";

interface ProgressBarProps {
  progress: number; // 0 to 100
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div className="fixed left-0 right-0 top-0 h-1 bg-oat">
      <div
        className="h-full bg-cantelope transition-all duration-300 ease-in-out"
        style={{ width: `${progressFillPercent(progress)}%` }}
      />
    </div>
  );
};

export default ProgressBar;
